import { useMemo, useState } from "react"

const useArrayState = <T>(initialStates: T[]) => {
  // 初回に呼ばれたときの、引数を保存する
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memorized = useMemo(() => initialStates, [])

  // 初期値の配列の長さの数だけuseStateを実行する
  // 初期値を固定しているのでループして呼んでも結果は固定される
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return memorized.map((state) => useState(state))
}

export default useArrayState
